import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavigationService } from 'i2g-ng-utils';
import { IRouter } from '../../interfaces/router.interface';

@Component({
  selector: 'app-go-back-button',
  templateUrl: 'go-back-button.component.html',
  styleUrls: ['go-back-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoBackButtonComponent {
  @Input() goBackRoute: IRouter | string;
  @Input() e2eId: string;
  @Input() colorMode: 'default' | 'reversed' = 'default';

  constructor(private _navigationService: NavigationService) {}
  onGoBack() {
    if ((this.goBackRoute as IRouter).route) {
      const goBackRoute = this.goBackRoute as IRouter;

      this._navigationService.goBack(
        goBackRoute.route,
        goBackRoute.navigationExtras
      );
    } else {
      this._navigationService.goBack(this.goBackRoute as string);
    }
  }
}
